module.exports = __webpack_public_path__ + "img/blank_avatar.d756ae5f.png";